<!-- To use a transparent background with this iframe, use <iframe src="stuff.htm" allowtransparency="true"></iframe> -->
@if (loaded() && !campaignInactive()) {
  <div
    class="wrapper"
    [class.is-dialog]="isDialog()"
    [class.is-embedded]="isEmbedded()"
    [ngStyle]="highContrast() ? { filter: 'saturate(0)' } : { filter: 'saturate(1)' }"
  >
    @if (!isDialog() && !isEmbedded() && showHeaderImg()) {
      <div class="wrapper-bg" role="banner">
        <div class="header-wrapper">
          <div class="header-image-wrapper">
            <div class="header-img" style="background-image:url('{{ townshipImage() }}');"></div>
          </div>
          <div class="header-text-button-wrapper">
            <h1 class="header-text">
              {{ townshipName() }}
            </h1>
            <div class="header-button-wrapper">
              <button (click)="setHighContrast()" mat-flat-button class="header-button">
                <mat-icon>contrast</mat-icon>
                Hoog contrast
              </button>
            </div>
          </div>
        </div>
      </div>
    }
    @if (noGroupProvided() || voucherGroup()) {
      <div class="activate-wrapper" [style.max-width]="pageWidth()">
        @if (voucherGroup() && voucherGroup().hideHeaderImage) {
          <div class="voucher-group-card-room"></div>
        }
        @if (voucherGroup() && !voucherGroup().hideHeaderImage) {
          <div class="voucher-group-card" [style.max-width]="pageWidth()">
            @if (voucherGroup().imageUrl) {
              <div class="avatar" style="background-image:url('{{ voucherGroup().imageUrl }}');"></div>
            }
            @if (!voucherGroup().imageUrl) {
              <div class="avatar placeholder">
                {{ voucherGroup()?.name[0] }}
              </div>
            }
            <div class="card-content">
              <div class="title-slogan">
                <div class="card-title">
                  {{ voucherGroup().name }}
                </div>
                @if (voucherGroup().slogan) {
                  <div class="slogan">
                    {{ voucherGroup().slogan }}
                  </div>
                }
              </div>
              <div class="voucher-value-wrapper">
                @if (voucherGroup().couponValue && !voucherGroup().altTextCouponValue) {
                  <div class="voucher-value">€{{ getCurrencyString(voucherGroup().couponValue) }}</div>
                }
                @if (!voucherGroup().altTextCouponValue) {
                  <div class="coupon">
                    {{ 'find-voucher-group.body.voucher' | translate }}
                  </div>
                }
                @if (voucherGroup().altTextCouponValue) {
                  <div class="alt-coupon">
                    {{ voucherGroup().altTextCouponValue }}
                  </div>
                }
              </div>
            </div>
          </div>
        }
        @if (voucherGroup()?.type !== 'sell') {
          <div class="activate-content">
            @if (!voucherGroup()?.hideVoucherRemainingInfo) {
              <div>
                @if (availableVouchers() > 0 && validDateToRequest() && !noStatistics()) {
                  <div class="statistics">
                    <div class="above" [ngClass]="isEmbedded() ? 'subtitle-embedded' : 'subtitle'">
                      {{ 'header.subtitle-above' | translate }}
                    </div>
                    <div [ngClass]="isEmbedded() ? 'statistic-embedded' : 'statistic'">
                      {{ availableVouchers() }}
                    </div>
                    <div [ngClass]="isEmbedded() ? 'subtitle-embedded' : 'subtitle'">
                      {{ 'header.subtitle-under' | translate: envName() }}
                    </div>
                    @if (acitvateDateNotPassed()) {
                      <div class="subtitle acitvateDateNotPassed">
                        <span>
                          <p>
                            {{ 'activate.warning.activate-date' | translate }}
                          </p>
                          {{ usableFromDate() | date: 'dd/MM' }}
                        </span>
                      </div>
                    }
                  </div>
                }
                @if (availableVouchers() <= 0 || !validDateToRequest()) {
                  <div class="statistics no-vouchers-available">
                    <!-- <div class="subtitle above">
                      {{ 'no-vouchers.message-above' | translate: envName() }}
                    </div>
                    <div class="subtitle">
                      {{ 'no-vouchers.message-under' | translate }}
                    </div> -->
                    <div class="subtitle-full">
                      {{ 'no-vouchers.message-full' | translate }}
                    </div>
                  </div>
                }
              </div>
            }
            @if (availableVouchers() > 0 || noGroupProvided()) {
              <form
                aria-label="voucher activeren formulier"
                class="activate-voucher-form"
                [style.max-width]="pageWidth()"
                [style.margin]="'0 auto'"
                (ngSubmit)="!inputData?.preparingRequest ? submit() : sendPreFilledForm()"
                [formGroup]="activateVoucherForm"
              >
                @if (activateVoucherForm.controls.number) {
                  <mat-form-field class="formfield-width-100">
                    <mat-label>
                      {{ 'activate.body.voucher-number' | translate }}
                    </mat-label>
                    <input formControlName="number" matInput required autocomplete="off" />
                    <mat-error>
                      {{ getError('number') }}
                    </mat-error>
                  </mat-form-field>
                }
                @if (activateVoucherForm.controls.name) {
                  <mat-form-field class="flex-class">
                    <mat-label>{{ 'input.name' | translate }}</mat-label>
                    <input formControlName="name" matInput autocomplete="name" />
                    @if (!nameRequired()) {
                      <mat-hint>Dit veld is optioneel</mat-hint>
                    }
                    <mat-error>
                      {{ getError('name') }}
                    </mat-error>
                  </mat-form-field>
                }
                @if (activateVoucherForm.controls.identification) {
                  <mat-form-field class="flex-class">
                    <mat-label>{{ 'input.identification' | translate }}</mat-label>
                    <input formControlName="identification" matInput required autocomplete="off" />
                    <mat-error>
                      {{ getError('identification') }}
                    </mat-error>
                  </mat-form-field>
                }
                @if (activateVoucherForm.controls.phone) {
                  <mat-form-field class="formfield-width-100">
                    <mat-label>{{ 'input.phone' | translate }}</mat-label>
                    <input
                      formControlName="phone"
                      matInput
                      required
                      placeholder="0612345678"
                      autocomplete="tel-national"
                    />
                    <mat-error>
                      {{ getError('phone') }}
                    </mat-error>
                  </mat-form-field>
                }
                <div role="group" aria-label="adresgegevens">
                  @if (this.data?.userData?.postal && this.data?.userData?.houseNumber) {
                    <div class="disabled-inputs">
                      @if (activateVoucherForm.controls.postal) {
                        <mat-form-field class="formfield-width-100 postal-input-spacing">
                          <mat-label>{{ 'input.postal' | translate }}</mat-label>
                          <input
                            formControlName="postal"
                            id="postal"
                            matInput
                            #postalCode
                            required
                            autocomplete="postal-code"
                            readonly
                            placeholder="1234AB"
                          />
                          <mat-error>
                            {{ getError('postal') }}
                          </mat-error>
                        </mat-form-field>
                      }
                      @if (activateVoucherForm.controls.houseNumber) {
                        <mat-form-field class="house-number-input">
                          <mat-label>{{ 'input.houseNumber' | translate }}</mat-label>
                          <input
                            formControlName="houseNumber"
                            matInput
                            autocomplete="address-line2"
                            required
                            id="houseNumber"
                            (keydown.space)="$event.preventDefault()"
                            type="text"
                            readonly
                          />
                          <mat-error>
                            {{ getError('houseNumber') }}
                          </mat-error>
                        </mat-form-field>
                      }
                      @if (activateVoucherForm.controls.houseNumberAddition) {
                        <mat-form-field class="house-number-addition-input">
                          <mat-label>{{ 'input.houseNumberAddition' | translate }}</mat-label>
                          <input
                            formControlName="houseNumberAddition"
                            matInput
                            id="houseNumberAddition"
                            autocomplete="off"
                            (keydown.space)="$event.preventDefault()"
                            readonly
                          />
                          <mat-hint>Dit veld is optioneel</mat-hint>
                          <mat-error>
                            {{ getError('houseNumberAddition') }}
                          </mat-error>
                        </mat-form-field>
                      }
                    </div>
                  }
                  @if (!this.data?.userData?.postal || !this.data?.userData?.houseNumber) {
                    <div class="enabledInputs">
                      @if (activateVoucherForm.controls.postal) {
                        <mat-form-field class="formfield-width-100 postal-input-spacing">
                          <mat-label>{{ 'input.postal' | translate }}</mat-label>
                          <input
                            pattern="[1-9][0-9]{3}[\s]?[A-Za-z]{2}"
                            formControlName="postal"
                            matInput
                            #postalCode
                            required
                            autocomplete="postal-code"
                            placeholder="1234AB"
                          />
                          <mat-error>
                            {{ getError('postal') }}
                          </mat-error>
                        </mat-form-field>
                      }
                      @if (activateVoucherForm.controls.houseNumber) {
                        <mat-form-field class="house-number-input">
                          <mat-label>{{ 'input.houseNumber' | translate }}</mat-label>
                          <input
                            formControlName="houseNumber"
                            matInput
                            autocomplete="address-line2"
                            required
                            (keydown.space)="$event.preventDefault()"
                            type="text"
                          />
                          <mat-error>
                            {{ getError('houseNumber') }}
                          </mat-error>
                        </mat-form-field>
                      }
                      @if (activateVoucherForm.controls.houseNumberAddition) {
                        <mat-form-field class="house-number-addition-input">
                          <mat-label>{{ 'input.houseNumberAddition' | translate }}</mat-label>
                          <input
                            formControlName="houseNumberAddition"
                            matInput
                            autocomplete="off"
                            (keydown.space)="$event.preventDefault()"
                          />
                          <mat-hint>Dit veld is optioneel</mat-hint>
                          <mat-error>
                            {{ getError('houseNumberAddition') }}
                          </mat-error>
                        </mat-form-field>
                      }
                    </div>
                  }
                </div>
                @if (activateVoucherForm.controls.bankAccountName) {
                  <div class="fieldset" role="group" aria-label="bankgegevens">
                    <mat-form-field class="formfield-width-100">
                      <mat-label>{{ 'input.name-bank-account-holder' | translate }}</mat-label>
                      <input formControlName="bankAccountName" matInput required autocomplete="name" />
                      <mat-error>
                        {{ getError('bankAccountName') }}
                      </mat-error>
                    </mat-form-field>
                    @if (activateVoucherForm.controls.ibanNumber) {
                      <mat-form-field class="formfield-width-100">
                        <mat-label>{{ 'input.iban-number' | translate }}</mat-label>
                        <input
                          formControlName="ibanNumber"
                          matInput
                          required
                          autocomplete="off"
                          placeholder="NL91ABNA0417164300"
                        />
                        <mat-error>
                          {{ getError('ibanNumber') }}
                        </mat-error>
                      </mat-form-field>
                    }
                  </div>
                }
                @if (activateVoucherForm.controls.email) {
                  <div class="fieldset" role="group" aria-label="email bevestigen">
                    <mat-form-field class="formfield-width-100">
                      <mat-label>{{ 'input.email' | translate }}</mat-label>
                      <input
                        formControlName="email"
                        matInput
                        required
                        (keydown.space)="$event.preventDefault()"
                        autocomplete="email"
                        placeholder="info@voorbeeld.nl"
                      />
                      <mat-error>
                        {{ getError('email') }}
                      </mat-error>
                    </mat-form-field>
                    @if (activateVoucherForm.controls.emailConfirm) {
                      <mat-form-field class="formfield-width-100">
                        <mat-label>{{ 'input.confirm-email' | translate }}</mat-label>
                        <input
                          formControlName="emailConfirm"
                          matInput
                          required
                          (keydown.space)="$event.preventDefault()"
                          autocomplete="email"
                          placeholder="info@voorbeeld.nl"
                        />
                        <mat-error>
                          {{ getError('emailConfirm') }}
                        </mat-error>
                      </mat-form-field>
                    }
                  </div>
                }
                @if (questionnaireEnabled()) {
                  <div class="questionnaire">
                    <div class="questionnaire-title">Enquêtevraag</div>
                    <form [formGroup]="questionnaireForm" aria-label="enquete formulier">
                      @for (questionData of questionnaireData | keyvalue; track questionData) {
                        <div>
                          <div class="questionnaire-question">
                            {{ questionData?.value.question }}
                          </div>
                          <mat-form-field>
                            <mat-label>Ik ben geinformeerd via</mat-label>
                            <mat-select
                              [formControlName]="questionData.key"
                              (selectionChange)="handleQuestionnaireQuestion(questionData?.key, $event.value)"
                            >
                              @for (answer of questionData?.value.answers; track answer; let i = $index) {
                                <mat-option [value]="i">
                                  {{ answer }}
                                </mat-option>
                              }
                            </mat-select>
                            <mat-error>
                              {{ getError(questionData.key, questionnaireForm) }}
                            </mat-error>
                          </mat-form-field>
                          @if (questionnaireForm.controls[$any(questionData.key) + 'Input']) {
                            <mat-form-field>
                              <mat-label>Anders, namelijk</mat-label>
                              <input
                                cdkFocusInitial
                                [formControlName]="$any(questionData.key) + 'Input'"
                                autocomplete="off"
                                matInput
                              />
                              <mat-error>
                                {{ getError($any(questionData.key) + 'Input', questionnaireForm) }}
                              </mat-error>
                            </mat-form-field>
                          }
                        </div>
                      }
                    </form>
                  </div>
                }
                @if (voucherGroup()?.terms && !data?.termsAccepted) {
                  <div class="terms-title">{{ 'activate.body.conditions' | translate }}</div>
                  <mat-form-field class="formfield-width-100" [class.voucher-terms]="availableVouchers() > 0">
                    <mat-label>{{ 'activate.body.conditions' | translate }}</mat-label>
                    <textarea
                      matInput
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="{{ this.termsRows() }}"
                      cdkAutosizeMaxRows="{{ this.termsRows() }}"
                      disabled="true"
                      value="{{ voucherGroup()?.terms }}"
                      readonly
                    ></textarea>
                  </mat-form-field>
                }
                @if (!data?.termsAccepted) {
                  <div class="terms-title">{{ 'terms.heading' | translate }}</div>
                  <a class="terms-link" [href]="termsUrl()" target="_blank" rel="noopener noreferrer">
                    {{ 'terms.general' | translate }}
                  </a>
                  <a class="terms-link" [href]="privacyUrl()" target="_blank" rel="noopener noreferrer">
                    {{ 'terms.privacy' | translate }}
                  </a>
                  <mat-checkbox class="terms-checkbox" formControlName="terms">
                    {{ 'activate.body.terms.accept' | translate }}
                  </mat-checkbox>
                }
              </form>
            }
          </div>
        }
        @if (!isEmbedded()) {
          <div class="actions" role="navigation" [style.max-width]="pageWidth()">
            @if (isDialog()) {
              <button mat-dialog-close mat-button>
                {{ 'activate.buttons.close' | translate }}
              </button>
            }
            <div></div>
            @if (!voucherGroupId()) {
              <button
                [class.spinner]="awaitingResponse()"
                (click)="submit()"
                [disabled]="!activateVoucherForm.valid || (questionnaireEnabled() && !questionnaireForm.valid)"
                mat-flat-button
              >
                {{ 'activate.buttons.activate' | translate }}
              </button>
            }
            @if (voucherGroup()?.type == 'activate') {
              <button
                [class.spinner]="awaitingResponse()"
                (click)="submit()"
                [disabled]="!activateVoucherForm.valid || (questionnaireEnabled() && !questionnaireForm.valid)"
                mat-flat-button
              >
                {{ 'activate.buttons.activate' | translate }}
              </button>
            }
            @if (voucherGroup()?.type == 'request') {
              <button
                [class.spinner]="awaitingResponse()"
                (click)="submit()"
                [disabled]="!activateVoucherForm.valid || (questionnaireEnabled() && !questionnaireForm.valid)"
                mat-flat-button
              >
                {{ 'activate.buttons.request' | translate }}
              </button>
            }
            <!-- @if (voucherGroup()?.type == 'requestActivated') {
              <button
                [class.spinner]="awaitingResponse()"
                (click)="submit()"
                [disabled]="!activateVoucherForm.valid || (questionnaireEnabled() && !questionnaireForm.valid)"
                mat-flat-button
              >
                {{ 'activate.buttons.request' | translate }}
              </button>
            } -->
          </div>
        }
        @if (isEmbedded() && isPreperationForm()) {
          <div role="navigation" class="actions" [style.max-width]="pageWidth()">
            <div></div>
            <button
              mat-flat-button
              class="spinner-button"
              (click)="sendPreFilledForm()"
              [disabled]="!activateVoucherForm.value.email || prefilledFormSent()"
            >
              {{ 'activate.buttons.preparedForm' | translate }}
              @if (awaitingResponse()) {
                <mat-spinner diameter="20"></mat-spinner>
              }
            </button>
          </div>
        }
        @if (isEmbedded() && !isPreperationForm()) {
          <div class="actions" [style.max-width]="pageWidth()">
            <div></div>
            @if (!voucherGroupId()) {
              <button
                mat-flat-button
                class="spinner-button"
                (click)="submit()"
                [disabled]="!activateVoucherForm.valid || (questionnaireEnabled() && !questionnaireForm.valid)"
              >
                {{ 'activate.buttons.activate' | translate }}
                @if (awaitingResponse()) {
                  <mat-spinner diameter="20"></mat-spinner>
                }
              </button>
            }
            @if (voucherGroup()?.type == 'activate') {
              <button
                mat-flat-button
                class="spinner-button"
                (click)="submit()"
                [disabled]="!activateVoucherForm.valid || (questionnaireEnabled() && !questionnaireForm.valid)"
              >
                {{ 'activate.buttons.activate' | translate }}
                @if (awaitingResponse()) {
                  <mat-spinner diameter="20"></mat-spinner>
                }
              </button>
            }
            @if (voucherGroup()?.type == 'request') {
              <button
                mat-flat-button
                class="spinner-button"
                (click)="submit()"
                [disabled]="!activateVoucherForm.valid || (questionnaireEnabled() && !questionnaireForm.valid)"
              >
                {{ 'activate.buttons.request' | translate }}
                @if (awaitingResponse()) {
                  <mat-spinner diameter="20"></mat-spinner>
                }
              </button>
            }
            <!-- @if (voucherGroup()?.type == 'requestActivated') {
              <button
                mat-flat-button
                class="spinner-button"
                (click)="submit()"
                [disabled]="!activateVoucherForm.valid || (questionnaireEnabled() && !questionnaireForm.valid)"
              >
                {{ 'activate.buttons.request' | translate }}
                @if (awaitingResponse()) {
                  <mat-spinner diameter="20"></mat-spinner>
                }
              </button>
            } -->
          </div>
        }
      </div>
    } @else {
      <div class="loading-wrapper" [ngClass]="activateType() === 'find-voucher-groups' ? 'find-voucher-groups' : ''">
        <div class="loading">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    }
  </div>
} @else if (campaignInactive()) {
  <div
    class="wrapper"
    [class.is-dialog]="isDialog()"
    [class.is-embedded]="isEmbedded()"
    [ngStyle]="highContrast() ? { filter: 'saturate(0)' } : { filter: 'saturate(1)' }"
  >
    @if (!isDialog() && !isEmbedded() && townshipImage()) {
      <div class="wrapper-bg" role="banner">
        <div class="header-wrapper">
          <div class="header-image-wrapper">
            <div class="header-img" style="background-image:url('{{ townshipImage() }}');"></div>
          </div>
          <div class="header-text-button-wrapper">
            <h1 class="header-text">{{ townshipName() }}</h1>
            <div class="header-button-wrapper">
              <button (click)="setHighContrast()" mat-flat-button class="header-button">
                <mat-icon>contrast</mat-icon>
                Hoog contrast
              </button>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="activate-wrapper">
      <p class="title">
        Het aanvragen en activeren van bonnen is niet meer mogelijk omdat deze campagne niet actief is.
      </p>
    </div>
  </div>
} @else {
  <div class="loading-wrapper" [ngClass]="activateType() === 'find-voucher-groups' ? 'find-voucher-groups' : ''">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
<!-- </div> -->
